<h1>
  <a class="home-link" [routerLink]="['/' + getHomePath()]">
    <i class="fa fa-home" aria-hidden="true"></i>
    {{'My company data' | translate}}
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="getLoading()" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>

  <div class="container-content" fxLayout fxLayoutAlign="space-between start">
    <form [formGroup]="getUpdateMyCompanyDataForm()" fxLayout="column" fxFlex novalidate class="ng"
          (ngSubmit)="updateCompanyData(getUpdateMyCompanyDataForm().value)">

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="companyLogo" class="control-label" fxFlex="30">
          {{'Logo' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex [ngStyle]="{'height': '102px'}"
             [ngClass]="{'invalid-photo': getUpdateMyCompanyDataForm().errors && (getUpdateMyCompanyDataForm().errors.invalidImageType || getUpdateMyCompanyDataForm().errors.invalidImageSize)}">

          <div class="add-photo-container" fxLayout="column" fxLayoutAlign="space-between end">
            <div class="photo-icon-container logo" [ngClass]="{'existing-photo': getUpdateMyCompanyDataForm().controls.companyLogo.value || getMyCompanyData().companyLogo}">
              <i class="fa fa-camera fa-lg" aria-hidden="true" [ngClass]="{'d-none': getUpdateMyCompanyDataForm().controls.companyLogo.value || getMyCompanyData().companyLogo}"></i>
              <img [src]="getUpdateMyCompanyDataForm().controls.companyLogo.value" [width]="100" [height]="100" [ngClass]="{'d-none': !getUpdateMyCompanyDataForm().controls.companyLogo.value}">
            </div>
            <div class="input-button-container" [ngClass]="{'two-buttons': getUpdateMyCompanyDataForm().controls.companyLogo.value}">
              <label for="companyLogo">
                <div class="select-image-btn" *ngIf="!getUpdateMyCompanyDataForm().controls.companyLogo.value && !getMyCompanyData().companyLogo">{{'Add logo' | translate}}</div>
                <div class="select-image-btn" *ngIf="getUpdateMyCompanyDataForm().controls.companyLogo.value || getMyCompanyData().companyLogo">{{'Change logo' | translate}}</div>
              </label>
              <input
                #fileInput
                type="file"
                class="fileInput"
                id="companyLogo"
                name="companyLogo"
                accept="image/*"
                (change)="onFileInputChange($event)">
            </div>
            <div class="remove-button-container" *ngIf="getUpdateMyCompanyDataForm().controls.companyLogo.value || getMyCompanyData().companyLogo">
              <div class="remove-image-btn" (click)="removeLogo()">{{'Remove logo' | translate}}</div>
            </div>
          </div>
          <div class="feedback-wrapper photo" *ngIf="getUpdateMyCompanyDataForm().errors" fxLayout="column">
            <small class="feedback">
              {{'Invalid image' | translate}}.
            </small>
            <small class="feedback" [hidden]="!getUpdateMyCompanyDataForm().errors.invalidImageType">
              {{'Please choose from one of the following image formats: jpg, jpeg, png, giff' | translate}}.
            </small>
            <small class="feedback" [hidden]="!getUpdateMyCompanyDataForm().errors.invalidImageSize">
              {{'The maximum photo size can be 2MBs' | translate}}.
            </small>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <div class="buttons-group" fxLayout fxLayout.xs="column" fxLayoutAlign="space-around center" fxLayoutGap="10px">
        <button class="btn btn-success save-btn" type="submit" [disabled]="getUpdateMyCompanyDataForm().invalid || getDisableForm()">
          {{'Save changes' | translate}}
        </button>
        <button (click)="cancelBtn()" class="btn btn-secondary" type="button">
          {{'Cancel' | translate}}
        </button>
      </div>

    </form>
  </div>
</div>
